import React, { lazy, Suspense } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { Loader } from "components";
import AuthenticatedRoute from "./AuthenticatedRoute";

// Load Routes dynamically for code splitting. Use webpackChunkName named chunks to better analyze the bundle size after building
const DashboardRoute = lazy(() => import(/* webpackChunkName: "DashboardRoute" */ "routes/Dashboard"));

const AccountRoute = lazy(() => import(/* webpackChunkName: "AccountRoute" */ "routes/Account"));

export const NotFoundRoute = lazy(() => import(/* webpackChunkName: "NotFoundRoute1" */ "routes/NotFound"));

export const AppRoutes = () => {
  return (
    <Suspense fallback={<Loader />}>
      <Routes>
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route
          path="/dashboard/*"
          element={
            <AuthenticatedRoute>
              <DashboardRoute />
            </AuthenticatedRoute>
          }
        />
        <Route path="/account/*" element={<AccountRoute />} />
        <Route path="*" element={<NotFoundRoute />} />
      </Routes>
    </Suspense>
  );
};

export default AppRoutes;
